import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  button {
    margin-top: 8px;
  }
`;

export const CurrentFileContainer = styled.div`
  width: 100%;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
`;
